import { FC } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  capitalizeFirstLetter,
  colors,
  formatYAxis,
  IAiChart,
  IPieChartConfig,
} from "./chartConfig";
import { useStyles } from "./AiGraphs.styles";

const AiPieChart: FC<IAiChart> = ({ config, chartData }) => {
  const styles = useStyles();

  const {
    data: { labels, values },
  } = config as IPieChartConfig;

  return (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={100}
          label={({ name, percent }) =>
            `${name}: ${(percent ? percent * 100 : 0).toFixed(0)}%`
          }
          dataKey={values.field}
          nameKey={labels.field}
        >
          {chartData.map((_, idx) => (
            <Cell key={`cell-${idx}`} fill={colors[idx % colors.length]} />
          ))}
        </Pie>

        <Tooltip formatter={(v) => formatYAxis(v)} />

        <Legend
          wrapperStyle={{ paddingTop: 30 }}
          content={({ payload }) => (
            <div className={styles.legendContainer}>
              {payload?.map((entry, index) => (
                <div key={`item-${index}`} className={styles.legendWrapper}>
                  <span
                    className={styles.legendIcon}
                    style={{ backgroundColor: entry.color }}
                  />
                  <span>{capitalizeFirstLetter(entry.value ?? "")}</span>
                </div>
              ))}
            </div>
          )}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default AiPieChart;
